<template>
  <div class="home-view" :class="{ 'no-select': !userStore.profile }">
    <ParticleCanvas />
    <div class="home-content">
      <HeroSection />
      <SkillsGrid />
      <Footer />
    </div>
  </div>
</template>

<script setup>
  import { onMounted, onUnmounted, inject } from 'vue'
  import { useUserStore } from '@/store/modules/user'
  import ParticleCanvas from '../components/common/ParticleCanvas.vue'
  import HeroSection from '../components/home/HeroSection.vue'
  import SkillsGrid from '../components/home/SkillsGrid.vue'
  import Footer from '../components/common/Footer.vue'

  const userStore = useUserStore()
  const loginUrl = inject('loginUrl')

  const handleCopy = (e) => {
    if (!userStore.profile) {
      e.preventDefault()
      window.location.href = loginUrl
    }
  }

  onMounted(() => {
    document.addEventListener('copy', handleCopy)
  })

  onUnmounted(() => {
    document.removeEventListener('copy', handleCopy)
  })
</script>

<style scoped>
  .home-view {
    min-height: 100vh;
    position: relative;
  }

  .home-content {
    position: relative;
    z-index: 10;
  }

  .no-select {
    user-select: none;
    -webkit-user-select: none;
  }
</style>
